<template lang="html">
  <section class="c-slider">
    <nav class="c-slider__nav c-slider__nav--left" :class="{ 's--hovered' : toggleHover && direction === 'prev' && !switchingSlides, 's--hide' : toggleHover && direction === 'next' }" @click.prevent="switchSlide('prev')">
      <div>
        <p>prev</p>
        <span>{{prevProjectTitle}}</span>
      </div>
    </nav>
    <nav class="c-slider__nav c-slider__nav--right" :class="{ 's--hovered' : toggleHover && direction === 'next' && !switchingSlides, 's--hide' : toggleHover && direction === 'prev' }" @click.prevent="switchSlide('next')">
      <div>
        <p>next</p>
        <span>{{nextProjectTitle}}</span>
      </div>
    </nav>
    <div>
      <slider-item :project="project" v-for="project in projects"></slider-item>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

import SliderItem from './SliderItem'

export default {
  components: {
    SliderItem
  },
  data () {
    return {
      switchingSlides: false,
      nextProjectTitle: '',
      prevProjectTitle: ''
    }
  },
  computed: {
    ...mapGetters([
      'projects',
      'currentIndex',
      'prevIndex',
      'nextIndex',
      'toggleHover',
      'requestNextSlide',
      'direction',
      'mousePosition',
      'mouseInWindow',
      'clientDimensions'
    ])
  },
  watch: {
    mouseInWindow () {
      if (this.toggleHover !== false && this.mouseInWindow === false) {
        // toggleHover false
        let direction = this.direction || null
        this.$store.dispatch('setToggleHover', false)
        this.$store.dispatch('setDirection', direction)
      }
    },
    mousePosition () {
      this.watchMousePositon()
    },
    requestNextSlide () {
      if (this.requestNextSlide !== false) {
        this.switchSlide('next')
        this.$store.dispatch('setRequestNextSlide', false)
      }
    },
    nextIndex () {
      this.nextProjectTitle = this.projects[this.nextIndex].shortTitle
    },
    prevIndex () {
      this.prevProjectTitle = this.projects[this.prevIndex].shortTitle
    }
  },
  methods: {
    watchMousePositon () {
      let hoverZone = this.clientDimensions.hoverZone

      if (this.toggleHover !== false && this.mousePosition.x > hoverZone && this.mousePosition.x < (this.clientDimensions.width - hoverZone)) {
        // toggleHover false
        this.$store.dispatch('setToggleHover', false)
        this.$store.dispatch('setDirection', this.direction)
      } else if (this.mouseInWindow) {
        // toggleHover true
        if (this.toggleHover === false && this.mousePosition.x < hoverZone) {
          this.$store.dispatch('setToggleHover', true)
          this.$store.dispatch('setDirection', 'prev')
        } else if (this.toggleHover === false && this.mousePosition.x > (this.clientDimensions.width - hoverZone)) {
          this.$store.dispatch('setToggleHover', true)
          this.$store.dispatch('setDirection', 'next')
        }
      }
    },
    onKeyUp (e) {
      if (!this.switchingSlides && !this.toggleHover) {
        if (e.keyCode === 39) {
          this.$store.dispatch('setDirection', 'next')
          this.switchSlide('next')
        }
        if (e.keyCode === 37) {
          this.$store.dispatch('setDirection', 'prev')
          this.switchSlide('prev')
        }
      }
    },
    switchSlide (requesuestedDirection) {
      let direction = requesuestedDirection

      if (!this.switchingSlides) {
        this.switchingSlides = true

        if (direction === 'next') {
          this.$store.dispatch('setCurrentIndex', this.currentIndex + 1)
        } else if (direction === 'prev') {
          this.$store.dispatch('setCurrentIndex', this.currentIndex - 1)
        }
      } else {
        console.warn('Can\'t translate ' + direction + ' slide at the moment')
      }
    },
    rebindAllSlides () {
      this.$store.dispatch('setToggleHover', false)
      this.switchingSlides = false

      this.$store.dispatch('setNextIndex', this.currentIndex + 1)
      this.$store.dispatch('setPrevIndex', this.currentIndex - 1)
      // this.$store.dispatch('setRebindSlides', true)
      for (var i = 0; i < this.$children.length; i++) {
        this.$children[i].reInitSlide()
      }

      setTimeout(() => {
        this.watchMousePositon()
      }, 10)
    }
  },
  mounted () {
    // Onload first time prepare slides positions
    this.$store.dispatch('setNextIndex', this.currentIndex + 1)
    this.$store.dispatch('setPrevIndex', this.currentIndex - 1)
  },
  created () {
    window.addEventListener('keyup', (e) => this.onKeyUp(e))
  }
}
</script>

<style lang="scss">
@import "../../vars";

.c-slider {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  > div {
    width: 100%;
    height: 100%;
  }

  &__nav {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 5%;
    position: absolute;
    top: 0;
    z-index: 50;
    width: 10%;
    height: 100%;
    cursor: pointer;

    > div {
      width: 100%;
      transform: translate3d(0, 22px, 0);
      transition: all ease .25s;
    }

    p {
      font-family: $proxima;
      font-weight: 800;
      color: $white;
      font-size: 18px;
      width: 100%;
      opacity: 1;
      margin: 0;
      transition: all ease .25s;
    }

    span {
      color: $orange;
      font-family: $proxima;
      font-size: 15px;
      line-height: 15px;
      opacity: 0;
      transition: all ease .25s;
    }

    @media screen and (max-width: $tablet) {
      > div {
        transform: translate3d(0, 0, 0);
      }

      p {
        color: $white;
      }

      span {
        opacity: 1;
      }
    }

    &.s--hovered {

      > div {
        transform: translate3d(0, 0px, 0);
        transition: all ease .25s;
      }

      p {
        color: $white;
        transition: all ease .25s;
        transition-delay: .15s;
      }

      span {
        opacity: 1;
        transition: all ease .25s;
      }
    }

    &.s--hide {
      opacity: 0;
      transition: all ease .25s;

      @media screen and (max-width: $tablet) {
        opacity: 1;
      }
    }

    &--left {
      left: 0;
      padding-left: 2.8%;

      > div {
        text-align: left;
      }
    }

    &--right {
      right: 0;
      padding-right: 2.8%;

      > div {
        text-align: right;
      }
    }
  }
}

@media screen and (max-width: $tablet) {
  .c-slider__nav {
    top: auto;
    bottom: 0;
    height: 120px;
    width: 50%;
    padding-bottom: 60px;
  }

  .c-slider__nav--left {
    left: 3px;
    padding-left: 5%;

    > div {
      text-align: left;
    }
  }

  .c-slider__nav--right {
    right: 4px;
    padding-right: 5%;

    > div {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Slider.vue?3439f80e